module.exports = __webpack_public_path__ + "img/9370.66468757.png";